import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import api from '../services/api';

// The job card stock forms available to arrange, with live item counts.
export function useCatalogScopes() {
  return useQuery({
    queryKey: ['stockCatalog', 'scopes'],
    queryFn: async () => (await api.get('/api/stock-catalog/scopes')).data,
    staleTime: 60_000,
  });
}

// One form's items, already in the order engineers see them.
export function useCatalogOrder(scope) {
  const params = new URLSearchParams({
    discipline: scope.discipline,
    region: scope.region,
    ...(scope.job_type ? { job_type: scope.job_type } : {}),
  });
  return useQuery({
    queryKey: ['stockCatalog', 'order', scope.discipline, scope.region, scope.job_type || 'standard'],
    queryFn: async () => (await api.get(`/api/stock-catalog/order?${params}`)).data,
    staleTime: 0,
  });
}

// Order and form membership save together — see the route comment.
export function useSaveCatalogOrder(scope) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({ categories, offFormIds }) =>
      (await api.put('/api/stock-catalog/order', {
        discipline: scope.discipline,
        region: scope.region,
        job_type: scope.job_type || null,
        categories,
        offFormIds,
      })).data,
    onSuccess: () => qc.invalidateQueries({ queryKey: ['stockCatalog', 'order'] }),
  });
}

// Pulls the catalog from the SKU managers on demand, rather than waiting for
// the 03:35 cron, so a SKU added this morning reaches the engineer forms now.
export function useResyncCatalog() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async () => (await api.post('/api/stock-catalog/resync')).data,
    onSuccess: () => qc.invalidateQueries({ queryKey: ['stockCatalog'] }),
  });
}
